(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["leif-v4-bundle"] && !Shopify.designMode) return;
  try {
    class LeifV4Bundle extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.lv4b__card'));
      if (!this.cards.length) return;

      const raw = this.querySelector('[data-lv4b-data]');
      let data = { options: [], variants: [] };
      if (raw) {
        try { data = JSON.parse(raw.textContent); } catch (e) { /* leave empty */ }
      }
      this.optionNames = (data.options || []).map((o) => o.name);
      this.variants = data.variants || [];

      const currency = this.dataset.currency || 'USD';
      const locale = document.documentElement.lang || 'en';
      const whole = new Intl.NumberFormat(locale, {
        style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0,
      });
      const cents = new Intl.NumberFormat(locale, {
        style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
      // Whole amounts read as $89, anything with cents keeps both digits ($160.20, never $160.2).
      this.money = (v) => (Math.round(v * 100) % 100 === 0 ? whole : cents).format(v);
      this.dollars = (d) => whole.format(d);

      this.percentMode = this.dataset.savingsMode === 'percent';
      this.section = this.closest('.shopify-section') || document;
      this.form = this.closest('form[action*="/cart/add"]') || this.section.querySelector('form[action*="/cart/add"]');
      this.formComponent = this.section.querySelector('product-form-component');
      this.picker = this.section.querySelector('variant-picker');
      this.setsWrap = this.querySelector('[data-role="sets"]');

      // Two things add a single line if left alone: the theme's delegated on:submit
      // handler, and the Slide Cart app embed, which watches form submits at window
      // capture and posts its own XHR add. Disarm the theme handler, and intercept
      // the click on the button itself so the submit event never fires at all. The
      // click runs before the browser turns it into a submit, so preventDefault here
      // silences both. The theme's fly-to-cart animation is a document capture click
      // handler and has already run by then, so it is kept.
      this.disarmNativeSubmit();
      const atcBtn = this.form ? this.form.querySelector('[ref="addToCartButton"]') : null;
      if (atcBtn && !atcBtn.dataset.linenOwned) {
        atcBtn.dataset.linenOwned = 'true';
        atcBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }
      if (this.form && !this.form.dataset.linenOwned) {
        this.form.dataset.linenOwned = 'true';
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.addToCart();
        });
      }

      const defCard = this.querySelector('.lv4b__card.is-selected') || this.cards[0];
      this.qty = parseInt(defCard.dataset.qty, 10) || 1;
      this.maxQty = Math.max.apply(null, this.cards.map((c) => parseInt(c.dataset.qty, 10) || 1));

      const init = this.initialSelection();
      this.sets = [];
      for (let i = 0; i < this.maxQty; i++) {
        this.sets.push({ opts: Object.assign({}, init), touched: false });
      }

      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.selectTier(card));
      });

      if (this.setsWrap) {
        this.setsWrap.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-opt-value]');
          if (!btn) return;
          const panel = btn.closest('[data-set]');
          if (!panel) return;
          this.pickValue(parseInt(panel.dataset.set, 10) - 1, btn.dataset.optName, btn.dataset.optValue);
        });
      }

      // Keep SET 1 in step with the hidden native picker. Its radios are the source
      // of the URL variant preselect, and every proxied click morphs them back in.
      if (this.picker && !this.picker.dataset.linenWatched) {
        this.picker.dataset.linenWatched = 'true';
        this.picker.addEventListener('change', () => this.syncFromPicker());
      }

      // Round 3 pickers: compact extra sets (dropdowns, a Change toggle). Only when the setting is on.
      if (this.dataset.xs && this.setsWrap) {
        this.setsWrap.addEventListener('change', (e) => {
          const sel = e.target.closest('select[data-opt-name]');
          if (!sel) return;
          const panel = sel.closest('[data-set]');
          if (!panel) return;
          this.pickValue(parseInt(panel.dataset.set, 10) - 1, sel.dataset.optName, sel.value);
        });
        this.setsWrap.addEventListener('click', (e) => {
          const btn = e.target.closest('.lv4b__change');
          if (!btn) return;
          const panel = btn.closest('[data-set]');
          if (!panel) return;
          const open = !panel.classList.contains('is-open');
          panel.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? btn.dataset.labelOpen : btn.dataset.labelClosed;
        });
      }

      this.render();
    }

    disarmNativeSubmit() {
      if (this.formComponent) this.formComponent.removeAttribute('on:submit');
    }

    pickerRadios(optName) {
      if (!this.picker) return [];
      const prefix = optName + '-';
      return Array.from(this.picker.querySelectorAll('input[type="radio"]')).filter(
        (r) => r.name && r.name.indexOf(prefix) === 0
      );
    }

    initialSelection() {
      const sel = {};
      this.optionNames.forEach((name) => {
        const checked = this.pickerRadios(name).find((r) => r.checked);
        if (checked) sel[name] = checked.value;
      });
      if (Object.keys(sel).length !== this.optionNames.length) {
        const v = this.variants.find((x) => x.a) || this.variants[0];
        if (v) {
          this.optionNames.forEach((name, i) => {
            if (!(name in sel)) sel[name] = v.o[i];
          });
        }
      }
      return sel;
    }

    syncFromPicker() {
      let changed = false;
      this.optionNames.forEach((name) => {
        const checked = this.pickerRadios(name).find((r) => r.checked);
        if (checked && this.sets[0].opts[name] !== checked.value) {
          this.sets[0].opts[name] = checked.value;
          changed = true;
        }
      });
      if (changed) {
        this.mirror();
        this.render();
      }
    }

    mirror() {
      for (let i = 1; i < this.sets.length; i++) {
        if (!this.sets[i].touched) this.sets[i].opts = Object.assign({}, this.sets[0].opts);
      }
    }

    pickValue(setIdx, optName, value) {
      const set = this.sets[setIdx];
      if (!set) return;
      set.opts[optName] = value;
      if (setIdx === 0) {
        this.mirror();
        // Route SET 1 through the hidden native picker so the price block, the
        // media gallery and the buy button all keep their native behaviour.
        const radio = this.pickerRadios(optName).find((r) => r.value === value);
        if (radio && !radio.checked) radio.click();
      } else {
        set.touched = true;
      }
      this.render();
    }

    selectTier(card) {
      // Round 4: the extra sets open or close ABOVE the cards, so measure the tapped card first and
      // scroll by the difference after the change, in the same frame: the card stays under her finger.
      const topBefore = card.getBoundingClientRect().top;
      this.cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.qty = parseInt(card.dataset.qty, 10) || 1;
      this.render();
      this.holdPlace(card, topBefore);
    }

    holdPlace(el, topBefore) {
      const diff = el.getBoundingClientRect().top - topBefore;
      if (Math.abs(diff) < 0.5) return;
      // The theme sets html { scroll-behavior: smooth }; switch it off for this one jump so nothing animates.
      const root = document.documentElement;
      const prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(window.scrollX, window.scrollY + diff);
      root.style.scrollBehavior = prev;
    }

    variantFor(opts) {
      return this.variants.find((v) => this.optionNames.every((name, i) => v.o[i] === opts[name]));
    }

    tierPricing(q, pct, amountSave) {
      let gross = 0;
      let was = 0;
      let save = 0;
      for (let i = 0; i < q; i++) {
        const set = this.sets[i] || this.sets[0];
        const v = set ? this.variantFor(set.opts) : null;
        if (!v) continue;
        gross += v.p;
        was += Math.max(v.c || 0, v.p);
        if (this.percentMode) {
          // Shopify rounds the percentage discount per line, so mirror that here
          // and the number on the card is exactly what the cart will charge.
          save += Math.round((v.p * pct) / 100);
        }
      }
      if (!this.percentMode) save = Math.round(amountSave * 100);
      return { gross, save, was, net: Math.max(0, gross - save) };
    }

    render() {
      this.disarmNativeSubmit();

      const showUnit = this.dataset.showUnit === 'true';
      const showTotal = this.dataset.showTotal === 'true';
      const perSetLabel = this.dataset.perSetLabel || '/ set';
      const saveLabel = this.dataset.saveLabel || 'Save';

      let chosen = null;
      this.cards.forEach((card) => {
        const q = parseInt(card.dataset.qty, 10) || 1;
        const pct = parseFloat(card.dataset.percent) || 0;
        const amt = parseFloat(card.dataset.savings) || 0;
        const p = this.tierPricing(q, pct, amt);

        // Whole dollars only (owner, round 2). Display only: the cart still charges p.net to the cent.
        // The was-price is the variants' compare-at price (the price row under the title is gone, owner 05:56),
        // so every card, 1 set included, shows now, was and the saving. Save = was minus now, both as shown.
        const wasD = Math.round(p.was / 100);
        const netD = Math.round(p.net / 100);
        const saveD = wasD - netD;
        const unitD = Math.round(p.net / q / 100);

        const grossEl = card.querySelector('[data-role="gross"]');
        if (grossEl) grossEl.textContent = saveD > 0 ? this.dollars(wasD) : '';

        const totalEl = card.querySelector('[data-role="total"]');
        if (totalEl && showTotal) totalEl.textContent = this.dollars(netD);

        const saveEl = card.querySelector('[data-role="save"]');
        if (saveEl) saveEl.textContent = saveD > 0 ? saveLabel + ' ' + this.dollars(saveD) : '';

        const unitEl = card.querySelector('[data-role="unit"]');
        if (unitEl && showUnit) unitEl.textContent = this.dollars(unitD) + ' ' + perSetLabel;
        if (q === this.qty) chosen = { q, netD, saveD };
      });

      // Round 4: one summary line under the cards, e.g. "2 sets · $214 · you save $186". Display only.
      const sumEl = this.querySelector('.lv4b__summary');
      if (sumEl && chosen) {
        const word = chosen.q === 1 ? (this.dataset.unitSingular || 'set') : (this.dataset.unitPlural || 'sets');
        const parts = sumEl.querySelectorAll('.lv4b__summary-part');
        if (parts.length === 3) {
          parts[0].textContent = chosen.q + ' ' + word;
          parts[1].textContent = this.dollars(chosen.netD);
          parts[2].textContent = chosen.saveD > 0 ? 'you save ' + this.dollars(chosen.saveD) : '';
          sumEl.classList.toggle('is-nosave', !(chosen.saveD > 0));
        }
      }

      const tierName = this.querySelector('[data-role="tier-name"]');
      if (tierName) {
        const word = this.qty === 1 ? (this.dataset.unitSingular || 'Set') : (this.dataset.unitPlural || 'Sets');
        tierName.textContent = this.qty + ' ' + word;
      }

      if (this.setsWrap) {
        this.setsWrap.classList.toggle('is-single', this.qty === 1);
        this.setsWrap.querySelectorAll('[data-set]').forEach((panel) => {
          const idx = parseInt(panel.dataset.set, 10) - 1;
          panel.classList.toggle('is-hidden', idx >= this.qty);
          const set = this.sets[idx];
          if (!set) return;

          panel.querySelectorAll('[data-opt-value]').forEach((btn) => {
            const on = set.opts[btn.dataset.optName] === btn.dataset.optValue;
            btn.classList.toggle('is-selected', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          panel.querySelectorAll('[data-role="optvalue"]').forEach((el) => {
            el.textContent = set.opts[el.dataset.optName] || '';
          });

          if (this.dataset.xs) {
            panel.querySelectorAll('select[data-opt-name]').forEach((sel) => {
              const v = set.opts[sel.dataset.optName];
              if (v != null && sel.value !== v) sel.value = v;
            });
            // Colour dot beside a summary or inside a colour dropdown: copy the fill of the matching set 1 swatch.
            panel.querySelectorAll('[data-role="cdot"]').forEach((dot) => {
              const name = dot.dataset.optName;
              const v = name ? set.opts[name] : null;
              const src = v != null
                ? this.querySelector('.lv4b__sw[data-opt-name="' + CSS.escape(name) + '"][data-opt-value="' + CSS.escape(v) + '"] .lv4b__swdot')
                : null;
              dot.setAttribute('style', src ? src.getAttribute('style') || '' : '');
            });
          }

          const choice = panel.querySelector('[data-role="choice"]');
          if (choice) {
            choice.textContent = this.optionNames
              .map((name) => set.opts[name])
              .filter(Boolean)
              .join(' · ');
          }
        });
      }
    }

    showError(msg) {
      const el = this.querySelector('[data-role="error"]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(this.errTimer);
      this.errTimer = setTimeout(() => { el.hidden = true; }, 5000);
    }

    async addToCart() {
      const items = [];
      for (let i = 0; i < this.qty; i++) {
        const set = this.sets[i];
        const v = set ? this.variantFor(set.opts) : null;
        if (!v) {
          this.showError('That combination is not available. Check each set.');
          return;
        }
        items.push({ id: v.id, quantity: 1 });
      }

      const container = this.form ? this.form.querySelector('add-to-cart-component') : null;
      if (container && container.disable) container.disable();

      const body = { items };
      const sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach((el) => {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      if (sectionIds.length) body.sections = sectionIds.join(',');

      const url =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
          credentials: 'same-origin',
        });
        const data = await res.json();
        if (data.status) {
          this.showError(data.description || data.message || 'Could not add to cart.');
          return;
        }

        // The store's cart UX is the Slide Cart app drawer. Refresh it and open it
        // through its public API when present.
        try {
          if (typeof window.SLIDECART_UPDATE === 'function') await window.SLIDECART_UPDATE();
        } catch (e) { /* drawer refresh is best effort */ }
        try {
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        } catch (e) { /* drawer open is best effort */ }

        // Same event contract as the theme's own product form, so the cart icon
        // bubble and any cart sections update without their code involved.
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: {},
          sourceId: (this.formComponent && this.formComponent.id) || 'leif-v4-bundle',
          data: {
            source: 'product-form-component',
            itemCount: items.length,
            productId: this.formComponent ? this.formComponent.dataset.productId : undefined,
            sections: data.sections,
          },
        };
        (this.formComponent || this).dispatchEvent(ev);

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = '/cart';
        }
      } catch (e) {
        this.showError('Could not add to cart. Try again.');
      } finally {
        if (container && container.enable) container.enable();
      }
    }
  }

  if (!customElements.get('leif-v4-bundle')) {
    customElements.define('leif-v4-bundle', LeifV4Bundle);
  }

  // Round 3, pure addition: the "Set 2 added above" line under the cards scrolls up to Set 2's heading.
  // Nothing in the element above is touched; this only reads the page.
  if (!window.__lv4bNoticeBound) {
    window.__lv4bNoticeBound = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.lv4b__notice');
      if (!btn) return;
      e.preventDefault();
      const root = btn.closest('.lv4b');
      const target = root ? root.querySelector('.lv4b__set[data-set="2"] .lv4b__set-head') : null;
      if (!target) return;
      // The theme header is sticky and slides back in when the page scrolls up, so always leave room for it.
      let offset = 16;
      document.querySelectorAll('.shopify-section-group-header-group').forEach((el) => {
        const pos = getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') offset = Math.max(offset, 16 + el.getBoundingClientRect().height);
      });
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["leif-v4-preorder-ship"] && !Shopify.designMode) return;
  try {
    class Lv4ShipBar extends HTMLElement {
    connectedCallback() {
      // Same logic as linen-shipping-countdown: count down to the cutoff hour in the chosen timezone (24 = midnight).
      this.el = this.querySelector('[data-role="timer"]');
      if (!this.el) return;
      this.tz = this.dataset.tz || 'America/Los_Angeles';
      this.cutoff = parseInt(this.dataset.cutoff, 10);
      if (isNaN(this.cutoff) || this.cutoff < 1 || this.cutoff > 24) this.cutoff = 24;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
    tick() {
      let now;
      try {
        now = new Date(new Date().toLocaleString('en-US', { timeZone: this.tz }));
      } catch (e) {
        now = new Date();
      }
      const next = new Date(now);
      if (this.cutoff === 24 || now.getHours() < this.cutoff) {
        next.setHours(this.cutoff, 0, 0, 0);
      } else {
        next.setDate(next.getDate() + 1);
        next.setHours(this.cutoff, 0, 0, 0);
      }
      const d = Math.max(0, next - now);
      const h = Math.floor(d / 3600000);
      const m = Math.floor((d % 3600000) / 60000);
      const sec = Math.floor((d % 60000) / 1000);
      this.el.textContent =
        (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    }
  }
  if (!customElements.get('lv4-ship-bar')) {
    customElements.define('lv4-ship-bar', Lv4ShipBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["leif-v4-preorder"] && !Shopify.designMode) return;
  try {
    class Lv4PreorderCard extends HTMLElement {
    connectedCallback() {
      // Same rolling-date logic as linen-batch-bar: batch 2 is always N days out, batch 3 follows by the gap.
      const days2 = parseInt(this.dataset.days2, 10) || 2;
      const gap3 = parseInt(this.dataset.gap3, 10) || 14;
      const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      const fmt = (d) => {
        const day = d.getDate();
        const suffix = (day % 10 === 1 && day !== 11) ? 'st'
          : (day % 10 === 2 && day !== 12) ? 'nd'
          : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
        return months[d.getMonth()] + ' ' + day + suffix;
      };
      const d2 = new Date(Date.now() + days2 * 86400000);
      const d3 = new Date(d2.getTime() + gap3 * 86400000);
      this.querySelectorAll('[data-role="batch2-date"]').forEach((el) => { el.textContent = fmt(d2); });
      this.querySelectorAll('[data-role="batch3-date"]').forEach((el) => { el.textContent = fmt(d3); });
    }
  }
  if (!customElements.get('lv4-preorder-card')) {
    customElements.define('lv4-preorder-card', Lv4PreorderCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linen-batch-bar"] && !Shopify.designMode) return;
  try {
    class LinenPreorderCard extends HTMLElement {
    connectedCallback() {
      // Rolling dates from the visitor's clock: batch 2 is always N days out,
      // batch 3 follows it by the configured gap. Overwrites the server paint,
      // so cached pages still show fresh dates.
      const days2 = parseInt(this.dataset.days2, 10) || 2;
      const gap3 = parseInt(this.dataset.gap3, 10) || 14;
      const fmt = (d) => {
        const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        const day = d.getDate();
        const suffix = (day % 10 === 1 && day !== 11) ? 'st'
          : (day % 10 === 2 && day !== 12) ? 'nd'
          : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
        return months[d.getMonth()] + ' ' + day + suffix;
      };
      const d2 = new Date(Date.now() + days2 * 86400000);
      const d3 = new Date(d2.getTime() + gap3 * 86400000);
      const el2 = this.querySelector('[data-role="batch2-date"]');
      const el3 = this.querySelector('[data-role="batch3-date"]');
      if (el2) el2.textContent = fmt(d2);
      if (el3) el3.textContent = fmt(d3);
    }
  }

  if (!customElements.get('linen-preorder-card')) {
    customElements.define('linen-preorder-card', LinenPreorderCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linen-bundle-ladder"] && !Shopify.designMode) return;
  try {
    class LinenBundleLadder extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.linen-ladder__card'));
      if (!this.cards.length) return;

      const raw = this.querySelector('[data-linen-data]');
      let data = { options: [], variants: [] };
      if (raw) {
        try { data = JSON.parse(raw.textContent); } catch (e) { /* leave empty */ }
      }
      this.optionNames = (data.options || []).map((o) => o.name);
      this.variants = data.variants || [];

      const currency = this.dataset.currency || 'USD';
      const locale = document.documentElement.lang || 'en';
      const whole = new Intl.NumberFormat(locale, {
        style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0,
      });
      const cents = new Intl.NumberFormat(locale, {
        style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
      // Whole amounts read as $89, anything with cents keeps both digits ($160.20, never $160.2).
      this.money = (v) => (Math.round(v * 100) % 100 === 0 ? whole : cents).format(v);

      this.percentMode = this.dataset.savingsMode === 'percent';
      this.section = this.closest('.shopify-section') || document;
      this.form = this.closest('form[action*="/cart/add"]') || this.section.querySelector('form[action*="/cart/add"]');
      this.formComponent = this.section.querySelector('product-form-component');
      this.picker = this.section.querySelector('variant-picker');
      this.setsWrap = this.querySelector('[data-role="sets"]');

      // Two things add a single line if left alone: the theme's delegated on:submit
      // handler, and the Slide Cart app embed, which watches form submits at window
      // capture and posts its own XHR add. Disarm the theme handler, and intercept
      // the click on the button itself so the submit event never fires at all. The
      // click runs before the browser turns it into a submit, so preventDefault here
      // silences both. The theme's fly-to-cart animation is a document capture click
      // handler and has already run by then, so it is kept.
      this.disarmNativeSubmit();
      const atcBtn = this.form ? this.form.querySelector('[ref="addToCartButton"]') : null;
      if (atcBtn && !atcBtn.dataset.linenOwned) {
        atcBtn.dataset.linenOwned = 'true';
        atcBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }
      if (this.form && !this.form.dataset.linenOwned) {
        this.form.dataset.linenOwned = 'true';
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.addToCart();
        });
      }

      const defCard = this.querySelector('.linen-ladder__card.is-selected') || this.cards[0];
      this.qty = parseInt(defCard.dataset.qty, 10) || 1;
      this.maxQty = Math.max.apply(null, this.cards.map((c) => parseInt(c.dataset.qty, 10) || 1));

      const init = this.initialSelection();
      this.sets = [];
      for (let i = 0; i < this.maxQty; i++) {
        this.sets.push({ opts: Object.assign({}, init), touched: false });
      }

      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.selectTier(card));
      });

      if (this.setsWrap) {
        this.setsWrap.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-opt-value]');
          if (!btn) return;
          const panel = btn.closest('[data-set]');
          if (!panel) return;
          this.pickValue(parseInt(panel.dataset.set, 10) - 1, btn.dataset.optName, btn.dataset.optValue);
        });
      }

      // Keep SET 1 in step with the hidden native picker. Its radios are the source
      // of the URL variant preselect, and every proxied click morphs them back in.
      if (this.picker && !this.picker.dataset.linenWatched) {
        this.picker.dataset.linenWatched = 'true';
        this.picker.addEventListener('change', () => this.syncFromPicker());
      }

      this.render();
    }

    disarmNativeSubmit() {
      if (this.formComponent) this.formComponent.removeAttribute('on:submit');
    }

    pickerRadios(optName) {
      if (!this.picker) return [];
      const prefix = optName + '-';
      return Array.from(this.picker.querySelectorAll('input[type="radio"]')).filter(
        (r) => r.name && r.name.indexOf(prefix) === 0
      );
    }

    initialSelection() {
      const sel = {};
      this.optionNames.forEach((name) => {
        const checked = this.pickerRadios(name).find((r) => r.checked);
        if (checked) sel[name] = checked.value;
      });
      if (Object.keys(sel).length !== this.optionNames.length) {
        const v = this.variants.find((x) => x.a) || this.variants[0];
        if (v) {
          this.optionNames.forEach((name, i) => {
            if (!(name in sel)) sel[name] = v.o[i];
          });
        }
      }
      return sel;
    }

    syncFromPicker() {
      let changed = false;
      this.optionNames.forEach((name) => {
        const checked = this.pickerRadios(name).find((r) => r.checked);
        if (checked && this.sets[0].opts[name] !== checked.value) {
          this.sets[0].opts[name] = checked.value;
          changed = true;
        }
      });
      if (changed) {
        this.mirror();
        this.render();
      }
    }

    mirror() {
      for (let i = 1; i < this.sets.length; i++) {
        if (!this.sets[i].touched) this.sets[i].opts = Object.assign({}, this.sets[0].opts);
      }
    }

    pickValue(setIdx, optName, value) {
      const set = this.sets[setIdx];
      if (!set) return;
      set.opts[optName] = value;
      if (setIdx === 0) {
        this.mirror();
        // Route SET 1 through the hidden native picker so the price block, the
        // media gallery and the buy button all keep their native behaviour.
        const radio = this.pickerRadios(optName).find((r) => r.value === value);
        if (radio && !radio.checked) radio.click();
      } else {
        set.touched = true;
      }
      this.render();
    }

    selectTier(card) {
      this.cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.qty = parseInt(card.dataset.qty, 10) || 1;
      this.render();
    }

    variantFor(opts) {
      return this.variants.find((v) => this.optionNames.every((name, i) => v.o[i] === opts[name]));
    }

    tierPricing(q, pct, amountSave) {
      let gross = 0;
      let save = 0;
      for (let i = 0; i < q; i++) {
        const set = this.sets[i] || this.sets[0];
        const v = set ? this.variantFor(set.opts) : null;
        if (!v) continue;
        gross += v.p;
        if (this.percentMode) {
          // Shopify rounds the percentage discount per line, so mirror that here
          // and the number on the card is exactly what the cart will charge.
          save += Math.round((v.p * pct) / 100);
        }
      }
      if (!this.percentMode) save = Math.round(amountSave * 100);
      return { gross, save, net: Math.max(0, gross - save) };
    }

    render() {
      this.disarmNativeSubmit();

      const showUnit = this.dataset.showUnit === 'true';
      const showTotal = this.dataset.showTotal === 'true';
      const perSetLabel = this.dataset.perSetLabel || '/ set';
      const saveLabel = this.dataset.saveLabel || 'Save';

      this.cards.forEach((card) => {
        const q = parseInt(card.dataset.qty, 10) || 1;
        const pct = parseFloat(card.dataset.percent) || 0;
        const amt = parseFloat(card.dataset.savings) || 0;
        const p = this.tierPricing(q, pct, amt);

        const grossEl = card.querySelector('[data-role="gross"]');
        if (grossEl) grossEl.textContent = p.save > 0 ? this.money(p.gross / 100) : '';

        const totalEl = card.querySelector('[data-role="total"]');
        if (totalEl && showTotal) totalEl.textContent = this.money(p.net / 100);

        const saveEl = card.querySelector('[data-role="save"]');
        if (saveEl) saveEl.textContent = p.save > 0 ? saveLabel + ' ' + this.money(p.save / 100) : '';

        const unitEl = card.querySelector('[data-role="unit"]');
        if (unitEl && showUnit) unitEl.textContent = this.money(p.net / q / 100) + ' ' + perSetLabel;
      });

      const tierName = this.querySelector('[data-role="tier-name"]');
      if (tierName) {
        const word = this.qty === 1 ? (this.dataset.unitSingular || 'Set') : (this.dataset.unitPlural || 'Sets');
        tierName.textContent = this.qty + ' ' + word;
      }

      if (this.setsWrap) {
        this.setsWrap.classList.toggle('is-single', this.qty === 1);
        this.setsWrap.querySelectorAll('[data-set]').forEach((panel) => {
          const idx = parseInt(panel.dataset.set, 10) - 1;
          panel.classList.toggle('is-hidden', idx >= this.qty);
          const set = this.sets[idx];
          if (!set) return;

          panel.querySelectorAll('[data-opt-value]').forEach((btn) => {
            const on = set.opts[btn.dataset.optName] === btn.dataset.optValue;
            btn.classList.toggle('is-selected', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          panel.querySelectorAll('[data-role="optvalue"]').forEach((el) => {
            el.textContent = set.opts[el.dataset.optName] || '';
          });

          const choice = panel.querySelector('[data-role="choice"]');
          if (choice) {
            choice.textContent = this.optionNames
              .map((name) => set.opts[name])
              .filter(Boolean)
              .join(' · ');
          }
        });
      }
    }

    showError(msg) {
      const el = this.querySelector('[data-role="error"]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(this.errTimer);
      this.errTimer = setTimeout(() => { el.hidden = true; }, 5000);
    }

    async addToCart() {
      const items = [];
      for (let i = 0; i < this.qty; i++) {
        const set = this.sets[i];
        const v = set ? this.variantFor(set.opts) : null;
        if (!v) {
          this.showError('That combination is not available. Check each set.');
          return;
        }
        items.push({ id: v.id, quantity: 1 });
      }

      const container = this.form ? this.form.querySelector('add-to-cart-component') : null;
      if (container && container.disable) container.disable();

      const body = { items };
      const sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach((el) => {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      if (sectionIds.length) body.sections = sectionIds.join(',');

      const url =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
          credentials: 'same-origin',
        });
        const data = await res.json();
        if (data.status) {
          this.showError(data.description || data.message || 'Could not add to cart.');
          return;
        }

        // The store's cart UX is the Slide Cart app drawer. Refresh it and open it
        // through its public API when present.
        try {
          if (typeof window.SLIDECART_UPDATE === 'function') await window.SLIDECART_UPDATE();
        } catch (e) { /* drawer refresh is best effort */ }
        try {
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        } catch (e) { /* drawer open is best effort */ }

        // Same event contract as the theme's own product form, so the cart icon
        // bubble and any cart sections update without their code involved.
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: {},
          sourceId: (this.formComponent && this.formComponent.id) || 'linen-bundle-ladder',
          data: {
            source: 'product-form-component',
            itemCount: items.length,
            productId: this.formComponent ? this.formComponent.dataset.productId : undefined,
            sections: data.sections,
          },
        };
        (this.formComponent || this).dispatchEvent(ev);

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = '/cart';
        }
      } catch (e) {
        this.showError('Could not add to cart. Try again.');
      } finally {
        if (container && container.enable) container.enable();
      }
    }
  }

  if (!customElements.get('linen-bundle-ladder')) {
    customElements.define('linen-bundle-ladder', LinenBundleLadder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linen-shipping-countdown"] && !Shopify.designMode) return;
  try {
    class LinenShippingCountdown extends HTMLElement {
    connectedCallback() {
      this.el = this.querySelector('[data-role="timer"]');
      if (!this.el) return;
      this.tz = this.dataset.tz || 'America/Los_Angeles';
      this.cutoff = parseInt(this.dataset.cutoff, 10);
      if (isNaN(this.cutoff) || this.cutoff < 1 || this.cutoff > 24) this.cutoff = 24;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      let now;
      try {
        now = new Date(new Date().toLocaleString('en-US', { timeZone: this.tz }));
      } catch (e) {
        now = new Date();
      }
      const next = new Date(now);
      if (this.cutoff === 24 || now.getHours() < this.cutoff) {
        next.setHours(this.cutoff, 0, 0, 0);
      } else {
        next.setDate(next.getDate() + 1);
        next.setHours(this.cutoff, 0, 0, 0);
      }
      const d = Math.max(0, next - now);
      const h = Math.floor(d / 3600000);
      const m = Math.floor((d % 3600000) / 60000);
      const sec = Math.floor((d % 60000) / 1000);
      this.el.textContent =
        (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    }
  }

  if (!customElements.get('linen-shipping-countdown')) {
    customElements.define('linen-shipping-countdown', LinenShippingCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linen-stat-grid"] && !Shopify.designMode) return;
  try {
    class LinenStatGrid extends HTMLElement {
  connectedCallback() {
    if (this.dataset.animate !== 'true' || this._bound) return;
    this._bound = true;
    const vals = Array.from(this.querySelectorAll('.ln-stats__val'));
    if (!vals.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      vals.forEach((el) => (el.textContent = el.dataset.target));
      return;
    }
    const dur = parseInt(this.dataset.duration, 10) || 1400;
    const run = () => {
      const t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        vals.forEach((el) => {
          const target = parseFloat(el.dataset.target) || 0;
          el.textContent = Math.round(target * eased);
        });
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            run();
            obs.disconnect();
          }
        });
      },
      { threshold: 0.35 }
    );
    io.observe(this);
  }
}
if (!customElements.get('linen-stat-grid')) customElements.define('linen-stat-grid', LinenStatGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pb-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('pb-review-slider')) return;

    class PbReviewSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pb-rv-track]');
        this.prev = this.querySelector('[data-pb-rv-prev]');
        this.next = this.querySelector('[data-pb-rv-next]');
        this.counter = this.querySelector('[data-pb-rv-counter]');
        this.nav = this.querySelector('[data-pb-rv-nav]');
        if (!this.track) return;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); });
        };
        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onClick = (e) => {
          const btn = e.target.closest('[data-pb-rv-more]');
          if (btn && this.contains(btn)) this.toggle(btn);
        };
        this.onKey = (e) => {
          if (e.target !== this.track) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        };
        this.onBlockSelect = (e) => {
          const card = e.target && e.target.closest ? e.target.closest('.pb-rv-card') : null;
          if (card && this.track.contains(card)) this.scrollToCard(card, false);
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', this.onKey);
        if (this.prev) this.prev.addEventListener('click', this.onPrev);
        if (this.next) this.next.addEventListener('click', this.onNext);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        // Speed 2026-10-30: no layout read while the page is still loading. The ResizeObserver's first
        // callback runs after the browser's own layout and before the slider is first painted, so the
        // Read more buttons, counter and arrows are set in that same frame (same look, no forced layout).
        this.ro = new ResizeObserver(() => this.refresh());
        this.ro.observe(this.track);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.refresh());
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.ro) this.ro.disconnect();
      }

      cards() {
        return Array.from(this.track.children).filter((c) => c.offsetParent !== null || c.getClientRects().length);
      }

      step() {
        const c = this.cards();
        if (c.length > 1) return c[1].offsetLeft - c[0].offsetLeft;
        return c.length ? c[0].offsetWidth : this.track.clientWidth;
      }

      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }

      scrollToCard(card, smooth) {
        const first = this.cards()[0];
        if (!first) return;
        const left = card.offsetLeft - first.offsetLeft;
        this.track.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' });
      }

      // Speed 2026-10-30: every layout value is read first, then the DOM is written, so one refresh costs
      // at most one layout instead of one per card (the old read-after-write order forced ~100 ms of layout).
      readNav() {
        const cards = this.cards();
        const left = this.track.scrollLeft;
        const width = this.track.clientWidth;
        const max = this.track.scrollWidth - width;
        let step = 0;
        if (cards.length > 1) step = cards[1].offsetLeft - cards[0].offsetLeft;
        else step = cards.length ? cards[0].offsetWidth : width;
        return { total: cards.length, left: left, width: width, max: max, step: step || 1 };
      }

      writeNav(m) {
        const total = m.total;
        const fits = m.max <= 2;
        let idx = Math.round(m.left / m.step) + 1;
        if (m.max > 2 && m.left >= m.max - 2) {
          const visible = Math.max(1, Math.round(m.width / m.step));
          idx = Math.max(idx, total - visible + 1);
        }
        idx = Math.min(Math.max(idx, 1), total || 1);
        if (this.nav) this.nav.hidden = fits || total < 2;
        const label = idx + ' / ' + total;
        if (this.counter && this.counter.textContent !== label) this.counter.textContent = label;
        if (this.prev) this.prev.disabled = m.left <= 2;
        if (this.next) this.next.disabled = m.left >= m.max - 2;
      }

      readClamp() {
        const out = [];
        this.querySelectorAll('.pb-rv-card').forEach((card) => {
          const text = card.querySelector('[data-pb-rv-text]');
          const btn = card.querySelector('[data-pb-rv-more]');
          if (!text || !btn || card.classList.contains('is-open')) return;
          out.push([btn, text.scrollHeight <= text.clientHeight + 2]);
        });
        return out;
      }

      writeClamp(list) {
        const more = this.dataset.more || 'Read more';
        list.forEach(([btn, fits]) => {
          if (btn.textContent !== more) btn.textContent = more;
          if (btn.getAttribute('aria-expanded') !== 'false') btn.setAttribute('aria-expanded', 'false');
          if (btn.hidden !== fits) btn.hidden = fits;
        });
      }

      refresh() {
        const clamp = this.readClamp();
        const nav = this.readNav();
        this.writeClamp(clamp);
        this.writeNav(nav);
      }

      update() { this.writeNav(this.readNav()); }

      checkClamp() { this.writeClamp(this.readClamp()); }

      toggle(btn) {
        const card = btn.closest('.pb-rv-card');
        if (!card) return;
        const open = card.classList.toggle('is-open');
        btn.textContent = open ? (this.dataset.less || 'Show less') : (this.dataset.more || 'Read more');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) this.checkClamp();
      }
    }

    customElements.define('pb-review-slider', PbReviewSlider);

    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('pb-review-slider').forEach((el) => {
        if (typeof el.update === 'function') { el.checkClamp(); el.update(); }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tf-bundle-ladder"] && !Shopify.designMode) return;
  try {
    class TfBundleLadder extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.linen-ladder__card'));
      if (!this.cards.length) return;

      const raw = this.querySelector('[data-linen-data]');
      let data = { options: [], variants: [] };
      if (raw) {
        try { data = JSON.parse(raw.textContent); } catch (e) { /* leave empty */ }
      }
      this.optionNames = (data.options || []).map((o) => o.name);
      this.variants = data.variants || [];
      // Value order per option (from the JSON, else first appearance in the variant list).
      this.optionValues = this.optionNames.map((name, i) => {
        const o = (data.options || [])[i];
        if (o && Array.isArray(o.values) && o.values.length) return o.values;
        const seen = [];
        this.variants.forEach((v) => { if (seen.indexOf(v.o[i]) === -1) seen.push(v.o[i]); });
        return seen;
      });

      const currency = this.dataset.currency || 'USD';
      const locale = document.documentElement.lang || 'en';
      const whole = new Intl.NumberFormat(locale, {
        style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0,
      });
      const cents = new Intl.NumberFormat(locale, {
        style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
      // Whole amounts read as $89, anything with cents keeps both digits ($160.20, never $160.2).
      this.money = (v) => (Math.round(v * 100) % 100 === 0 ? whole : cents).format(v);

      this.percentMode = this.dataset.savingsMode === 'percent';
      this.section = this.closest('.shopify-section') || document;
      this.form = this.closest('form[action*="/cart/add"]') || this.section.querySelector('form[action*="/cart/add"]');
      this.formComponent = this.section.querySelector('product-form-component');
      this.picker = this.section.querySelector('variant-picker');
      this.setsWrap = this.querySelector('[data-role="sets"]');
      this.extraWrap = this.querySelector('[data-role="extra-sets"]');
      this.hideOpt = this.dataset.hideOption || '';
      this.hideVal = this.dataset.hideValue || '';
      // Values with no button and no extra-set option (|A|B| list from the hide_values setting).
      this.hideVals = new Set((this.dataset.hideValues || '').split('|').map((x) => x.trim()).filter(Boolean));

      // Two things add a single line if left alone: the theme's delegated on:submit
      // handler, and the Slide Cart app embed, which watches form submits at window
      // capture and posts its own XHR add. Disarm the theme handler, and intercept
      // the click on the button itself so the submit event never fires at all. The
      // click runs before the browser turns it into a submit, so preventDefault here
      // silences both. The theme's fly-to-cart animation is a document capture click
      // handler and has already run by then, so it is kept.
      this.disarmNativeSubmit();
      const atcBtn = this.form ? this.form.querySelector('[ref="addToCartButton"]') : null;
      if (atcBtn && !atcBtn.dataset.linenOwned) {
        atcBtn.dataset.linenOwned = 'true';
        atcBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }
      if (this.form && !this.form.dataset.linenOwned) {
        this.form.dataset.linenOwned = 'true';
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.addToCart();
        });
      }

      const defCard = this.querySelector('.linen-ladder__card.is-selected') || this.cards[0];
      this.qty = parseInt(defCard.dataset.qty, 10) || 1;
      this.maxQty = Math.max.apply(null, this.cards.map((c) => parseInt(c.dataset.qty, 10) || 1));

      const init = this.initialSelection();
      this.sets = [];
      for (let i = 0; i < this.maxQty; i++) {
        this.sets.push({ opts: Object.assign({}, init), touched: false });
      }

      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.selectTier(card));
      });

      if (this.extraWrap) {
        this.extraWrap.addEventListener('change', (e) => {
          const sel = e.target.closest('select[data-opt-name]');
          const row = sel && sel.closest('[data-xset]');
          if (!row) return;
          this.pickValue(parseInt(row.dataset.xset, 10) - 1, sel.dataset.optName, sel.value);
        });
      }

      // The hidden option (Set: Without Shams) is fixed on every set, including set 1's native picker.
      if (this.hideOpt && this.hideVal) {
        const radio = this.pickerRadios(this.hideOpt).find((r) => r.value === this.hideVal);
        if (radio && !radio.checked) radio.click();
      }

      // A hidden value (e.g. Queen Square from a ?variant= link) was swapped for the first visible
      // value in initialSelection; move the hidden native picker to match so price, gallery and URL agree.
      if (this.hideVals.size) {
        this.optionNames.forEach((name) => {
          if (name === this.hideOpt) return;
          const radios = this.pickerRadios(name);
          const cur = radios.find((r) => r.checked);
          const want = this.sets[0].opts[name];
          if (cur && cur.value !== want) {
            const radio = radios.find((r) => r.value === want);
            if (radio) radio.click();
          }
        });
      }

      if (this.setsWrap) {
        this.setsWrap.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-opt-value]');
          if (!btn) return;
          const panel = btn.closest('[data-set]');
          if (!panel) return;
          this.pickValue(parseInt(panel.dataset.set, 10) - 1, btn.dataset.optName, btn.dataset.optValue);
        });
      }

      // Keep SET 1 in step with the hidden native picker. Its radios are the source
      // of the URL variant preselect, and every proxied click morphs them back in.
      if (this.picker && !this.picker.dataset.linenWatched) {
        this.picker.dataset.linenWatched = 'true';
        this.picker.addEventListener('change', () => this.syncFromPicker());
      }

      this.render();
    }

    disarmNativeSubmit() {
      if (this.formComponent) this.formComponent.removeAttribute('on:submit');
    }

    pickerRadios(optName) {
      if (!this.picker) return [];
      const prefix = optName + '-';
      return Array.from(this.picker.querySelectorAll('input[type="radio"]')).filter(
        (r) => r.name && r.name.indexOf(prefix) === 0
      );
    }

    initialSelection() {
      const sel = {};
      this.optionNames.forEach((name) => {
        const checked = this.pickerRadios(name).find((r) => r.checked);
        if (checked) sel[name] = checked.value;
      });
      if (Object.keys(sel).length !== this.optionNames.length) {
        const v = this.variants.find((x) => x.a) || this.variants[0];
        if (v) {
          this.optionNames.forEach((name, i) => {
            if (!(name in sel)) sel[name] = v.o[i];
          });
        }
      }
      return this.fixHidden(this.fixHiddenValues(sel));
    }

    isHiddenValue(value) {
      return this.hideVals.size > 0 && this.hideVals.has(value);
    }

    // Swap any hidden value for the first visible value of that option that makes a real variant
    // (an available one first). Never returns a hidden value while a visible one exists.
    fixHiddenValues(sel) {
      if (!this.hideVals.size) return sel;
      this.optionNames.forEach((name, i) => {
        if (name === this.hideOpt) return;
        if (!this.isHiddenValue(sel[name])) return;
        const visible = (this.optionValues[i] || []).filter((x) => !this.isHiddenValue(x));
        if (!visible.length) return;
        const test = (val, needAvail) => {
          const opts = this.fixHidden(Object.assign({}, sel, { [name]: val }));
          const v = this.variantFor(opts);
          return v && (!needAvail || v.a);
        };
        sel[name] = visible.find((x) => test(x, true)) || visible.find((x) => test(x, false)) || visible[0];
      });
      return sel;
    }

    fixHidden(sel) {
      if (this.hideOpt && this.hideVal && this.optionNames.indexOf(this.hideOpt) !== -1) sel[this.hideOpt] = this.hideVal;
      return sel;
    }

    syncFromPicker() {
      let changed = false;
      this.optionNames.forEach((name) => {
        const checked = this.pickerRadios(name).find((r) => r.checked);
        if (name === this.hideOpt && this.hideVal) return;
        if (checked && this.isHiddenValue(checked.value)) return;
        if (checked && this.sets[0].opts[name] !== checked.value) {
          this.sets[0].opts[name] = checked.value;
          changed = true;
        }
      });
      if (changed) {
        this.mirror();
        this.render();
      }
    }

    mirror() {
      for (let i = 1; i < this.sets.length; i++) {
        if (!this.sets[i].touched) this.sets[i].opts = Object.assign({}, this.sets[0].opts);
      }
    }

    pickValue(setIdx, optName, value) {
      const set = this.sets[setIdx];
      if (!set) return;
      if (this.isHiddenValue(value)) return;
      set.opts[optName] = value;
      if (setIdx === 0) {
        this.mirror();
        // Route SET 1 through the hidden native picker so the price block, the
        // media gallery and the buy button all keep their native behaviour.
        const radio = this.pickerRadios(optName).find((r) => r.value === value);
        if (radio && !radio.checked) radio.click();
      } else {
        set.touched = true;
      }
      this.render();
    }

    selectTier(card) {
      this.cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.qty = parseInt(card.dataset.qty, 10) || 1;
      this.render();
    }

    variantFor(opts) {
      return this.variants.find((v) => this.optionNames.every((name, i) => v.o[i] === opts[name]));
    }

    tierPricing(q, pct, amountSave) {
      let gross = 0;
      let was = 0;
      let save = 0;
      for (let i = 0; i < q; i++) {
        const set = this.sets[i] || this.sets[0];
        const v = set ? this.variantFor(set.opts) : null;
        if (!v) continue;
        gross += v.p;
        // Was-price: the variant's compare-at price (Liquid falls back to the price when blank),
        // never below the real price. Display only; the cart math below is untouched.
        was += Math.max(v.c || 0, v.p);
        if (this.percentMode) {
          // Shopify rounds the percentage discount per line, so mirror that here
          // and the number on the card is exactly what the cart will charge.
          save += Math.floor((v.p * pct) / 100); // Shopify rounds each item's % discount down
        }
      }
      if (!this.percentMode) save = Math.round(amountSave * 100);
      return { gross, was, save, net: Math.max(0, gross - save) };
    }

    render() {
      this.disarmNativeSubmit();

      const showUnit = this.dataset.showUnit === 'true';
      const showTotal = this.dataset.showTotal === 'true';
      const perSetLabel = this.dataset.perSetLabel || '/ set';
      const saveLabel = this.dataset.saveLabel || 'Save';

      this.cards.forEach((card) => {
        const q = parseInt(card.dataset.qty, 10) || 1;
        const pct = parseFloat(card.dataset.percent) || 0;
        const amt = parseFloat(card.dataset.savings) || 0;
        const p = this.tierPricing(q, pct, amt);

        // Every card (1 set included) shows the struck was-price (compare-at x sets) and the real price;
        // Save = was minus real, as on the linen page. The real price p.net is the cart price to the cent.
        const off = Math.max(p.was, p.gross) - p.net;

        const grossEl = card.querySelector('[data-role="gross"]');
        if (grossEl) grossEl.textContent = off > 0 ? this.money(Math.max(p.was, p.gross) / 100) : '';

        const totalEl = card.querySelector('[data-role="total"]');
        if (totalEl && showTotal) totalEl.textContent = this.money(p.net / 100);

        const saveEl = card.querySelector('[data-role="save"]');
        if (saveEl) saveEl.textContent = off > 0 ? saveLabel + ' ' + this.money(off / 100) : '';

        const unitEl = card.querySelector('[data-role="unit"]');
        if (unitEl && showUnit) unitEl.textContent = this.money(p.net / q / 100) + ' ' + perSetLabel;
      });

      const tierName = this.querySelector('[data-role="tier-name"]');
      if (tierName) {
        const word = this.qty === 1 ? (this.dataset.unitSingular || 'Set') : (this.dataset.unitPlural || 'Sets');
        tierName.textContent = this.qty + ' ' + word;
      }

      this.renderExtra();

      if (this.setsWrap) {
        this.setsWrap.classList.toggle('is-single', this.qty === 1);
        this.setsWrap.querySelectorAll('[data-set]').forEach((panel) => {
          const idx = parseInt(panel.dataset.set, 10) - 1;
          panel.classList.toggle('is-hidden', idx >= this.qty);
          const set = this.sets[idx];
          if (!set) return;

          panel.querySelectorAll('[data-opt-value]').forEach((btn) => {
            const on = set.opts[btn.dataset.optName] === btn.dataset.optValue;
            btn.classList.toggle('is-selected', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          panel.querySelectorAll('[data-role="optvalue"]').forEach((el) => {
            el.textContent = set.opts[el.dataset.optName] || '';
          });

        });
      }
    }

    renderExtra() {
      if (!this.extraWrap) return;
      this.extraWrap.querySelectorAll('[data-xset]').forEach((row) => {
        const idx = parseInt(row.dataset.xset, 10) - 1;
        row.classList.toggle('is-hidden', idx >= this.qty);
        const set = this.sets[idx];
        if (!set) return;
        row.querySelectorAll('select[data-opt-name]').forEach((sel) => {
          const v = set.opts[sel.dataset.optName];
          if (v && sel.value !== v) sel.value = v;
          const dot = sel.parentElement.querySelector('[data-role="dot"]');
          const opt = sel.options[sel.selectedIndex];
          if (dot) dot.style.background = (opt && opt.dataset.sw) || 'transparent';
        });
      });
    }

    showError(msg) {
      const el = this.querySelector('[data-role="error"]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(this.errTimer);
      this.errTimer = setTimeout(() => { el.hidden = true; }, 5000);
    }

    async addToCart() {
      const items = [];
      for (let i = 0; i < this.qty; i++) {
        const set = this.sets[i];
        const v = set ? this.variantFor(set.opts) : null;
        if (!v) {
          this.showError('That combination is not available. Check each set.');
          return;
        }
        items.push({ id: v.id, quantity: 1 });
      }

      const container = this.form ? this.form.querySelector('add-to-cart-component') : null;
      if (container && container.disable) container.disable();

      const body = { items };
      const sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach((el) => {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      if (sectionIds.length) body.sections = sectionIds.join(',');

      const url =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
          credentials: 'same-origin',
        });
        const data = await res.json();
        if (data.status) {
          this.showError(data.description || data.message || 'Could not add to cart.');
          return;
        }

        // The store's cart UX is the Slide Cart app drawer. Refresh it and open it
        // through its public API when present.
        try {
          if (typeof window.SLIDECART_UPDATE === 'function') await window.SLIDECART_UPDATE();
        } catch (e) { /* drawer refresh is best effort */ }
        try {
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        } catch (e) { /* drawer open is best effort */ }

        // Same event contract as the theme's own product form, so the cart icon
        // bubble and any cart sections update without their code involved.
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: {},
          sourceId: (this.formComponent && this.formComponent.id) || 'tf-bundle-ladder',
          data: {
            source: 'product-form-component',
            itemCount: items.length,
            productId: this.formComponent ? this.formComponent.dataset.productId : undefined,
            sections: data.sections,
          },
        };
        (this.formComponent || this).dispatchEvent(ev);

        if (this.dataset.afterAdd === 'cart') {
          window.location.href = '/cart';
        }
      } catch (e) {
        this.showError('Could not add to cart. Try again.');
      } finally {
        if (container && container.enable) container.enable();
      }
    }
  }

  if (!customElements.get('tf-bundle-ladder')) {
    customElements.define('tf-bundle-ladder', TfBundleLadder);
  }
  } catch(e) { console.error(e); }
})();

})();
